import { Services } from '@sigma-frontend-libs/commons'
import { EOtpChannelTypes, EOtpTemplateChannelTypes } from '@sigmasms/shared-types'

export const getChannelTypes = service => {
  switch (service) {
    case Services['otp-settings/channels']: return Object.values(EOtpChannelTypes)
    case Services['otp-settings/templates']: return Object.values(EOtpTemplateChannelTypes)
  }
}
